/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-undef */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Image from 'next/image';
import { Button, Dialog, Input, MobileInput, Typography } from '@pwskills/rachnaui';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { randomId } from '@pwskills/rachnaui/utils';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { toast } from 'react-toastify';
import downArrow from '@/assets/icons/caret-down.svg';
import { useRouter } from 'next/router';
import useIsCourseBought from '@/hooks/useIsCourseBought';
import { getPPClientDetails } from '@/utils/helper/helperFunction';
import { useCaptchaConfig } from '@/hooks/useCaptchaConfig';
import LeadCaptureForm from './LeadCaptureForm';
import LeadCaptureModal from './LeadCaptureModal';
import Saving from './Saving';
import { isEmail, isName, isValidIndianPhoneNumber } from '../../../utils/common/common.validation';
import {
  penPencilClientId,
  penPencilTokenClientId,
  penPencilTokenClientSecret,
  penPencilTokenGrantType,
  s3Url,
} from '../../../utils/common/env.constants';
import moEvent from '../../../utils/moEngage';
import LeadCaptureApi from '../../../api/leadCapture';
import CategoryPageApi from '../../../api/categoryPage';
import CourseDescription from '../../../api/courseDescription';
import OnlineDegreePageApi from '../../../api/onlineDegree';
import CourseDescriptionContext from '../../../context/CourseDescriptionContext';
import {
  BackgroundFormItem,
  LeadCaptureType,
  LeadType,
  ModalType,
  WorkExperienceFormItem,
} from '../../../interfaces/leadCapture.enum';
import { IFilterApiPayload, IPayloadFilter } from '../../../interfaces/courseListing';
import CourseListingApi from '../../../api/courseListing';
import { IError } from '../../../interfaces/common';
import CategoryPageContext from '../../../context/CategoryPageContext';
import { IObjDataDb, LeadCaptureProps } from '../../../interfaces/leadCapture';
import { GAevent } from '../../../utils/firebase.utils';
import {
  sendSkFormStartedEvent,
  sendSkFormSubmittedEvent,
  sendSkOtpRequestInitiatedEvent,
} from '../../../utils/GAEventFunction';
import useUserDetails from '../../../store/userDetails';
import { useCaptcha } from '../Captcha';
import { CAPTCHA_WIDGET_IDS } from '../Captcha/constants';

type ContactDetails = {
  fullName: string;
  email?: string;
  isdCode: string;
  phoneNumber: string;
  source?: string;
  medium?: string;
  campaign?: string;
  category_name?: string;
};

type Error = { nameError: boolean; emailError: boolean; phoneNumberError: boolean };

const AUTO_CLOSE_TIME = 5000;

const LeadCapture = ({
  leadCaptureType,
  modelOpen,
  setModelOpen,
  buttonText,
  modalType,
  type,
  redirectLink,
  courseId,
  categoryId,
  courseName,
  collegeName,
  categoryName,
  enquiryType,
  enquiryTypeNPF,
  img,
  msgLineOne,
  msgLineTwo,
  curriculumPdf,
  reportLink,
  pageName,
  sourceName,
}: LeadCaptureProps) => {
  // const { user, isLoggedIn } = useContext(UserDetailsContext);
  const { userDetails: user, userIsLoggedIn: isLoggedIn } = useUserDetails();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean | null>(null);
  const [isValidName, setIsValidName] = useState(false);
  const [otp, setOtp] = useState('');
  const [dropDownBackground, setDropDownBackground] = useState(false);
  const [dropDownWorkExperience, setDropDownWorkExperience] = useState(false);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState<boolean>(
    !!(isLoggedIn && user.phoneNumber)
  );
  const [selectedBackground, setSelectedBackground] = useState('');
  const [selectedWorkExperience, setSelectedWorkExperience] = useState('');
  const [count, setCount] = useState(AUTO_CLOSE_TIME / 1000);
  const [currentTimerCount, setCurrentTimerCount] = useState(0);
  const utmQuery = useUTMParameters();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [selectedDropdownOption, setSelectedDropdownOption] = useState('');
  const [selectedDropdownCourseId, setSelectedDropdownCourseId] = useState('');
  const [dropdownOptions, setDropDownOptions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const router = useRouter();
  const [pageNo, setPageNo] = useState(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const downloadDirectly =
    isLoggedIn &&
    modalType !== ModalType.ONLINE_DEGREE &&
    leadCaptureType === LeadCaptureType.MODAL;
  const { checkIsCourseBought } = useIsCourseBought();
  const [isError, setIsError] = useState<Error>({
    emailError: false,
    nameError: false,
    phoneNumberError: false,
  });
  const { categorySlug } = router.query;
  const scrollableDivRef = useRef<HTMLDivElement | null>(null);
  const anchorRef = useRef<HTMLAnchorElement | null>(null);
  const [saving, setSaving] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [contactDetails, setContactDetails] = useState<ContactDetails>({
    fullName: isLoggedIn ? `${user.firstName} ${user.lastName}` : '',
    email: isLoggedIn ? user.email : '',
    isdCode: (isLoggedIn && user.isdCode) || '',
    phoneNumber: isLoggedIn ? user.phoneNumber : '',
  });

  const [isCourseBought, setIsCourseBought] = useState<boolean>(false);
  const { categoryDetails } = useContext(CategoryPageContext);
  const skFormStartedTrackedRef = useRef(false);
  const otpAttemptCountRef = useRef(0);
  const otpResendCountRef = useRef(0);
  const [captchaToken, setCaptchaToken] = useState<string>();
  const captcha = useCaptcha();
  const { isCaptchaEnabled, captchaConfig } = useCaptchaConfig();

  const INITIAL_TIMER_COUNT = 15;
  const SMS_TYPE = '1';

  // Helper function to get the appropriate captcha widget ID based on lead capture type
  const getCaptchaWidgetId = () => {
    return leadCaptureType === LeadCaptureType.FORM
      ? CAPTCHA_WIDGET_IDS.LEAD_CAPTURE_FORM
      : CAPTCHA_WIDGET_IDS.LEAD_CAPTURE_MODAL;
  };

  // Helper function to reset captcha if enabled
  const resetCaptchaIfEnabled = () => {
    if (isCaptchaEnabled) {
      setCaptchaToken('');
      captcha?.reset(getCaptchaWidgetId());
    }
  };

  const dropdownBackgroundOptions = [
    { title: BackgroundFormItem.WORKING_PROFESSIONAL },
    { title: BackgroundFormItem.GRADUATE },
    { title: BackgroundFormItem.COLLEGE_STUDENT },
  ];

  const dropDownWorkExOptions = [
    { title: WorkExperienceFormItem.BEGINNER },
    { title: WorkExperienceFormItem.EXPERIENCED },
    { title: WorkExperienceFormItem.ADVANCED },
    { title: WorkExperienceFormItem.PRO },
  ];

  const sendGAEvent = (eventName: string) => {
    const GAEventData = {
      work_experience: selectedWorkExperience,
      background: selectedBackground,
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
    };
    GAevent(eventName, GAEventData);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (value.length > 0 && value.trim() !== '') {
      setIsValidName(true);
    } else {
      setIsValidName(false);
    }

    setContactDetails((prevState) => ({ ...prevState, [name]: value }));
  };

  const payloadLabel: Record<string, keyof IPayloadFilter> = {
    program_type: 'programType',
    level_type: 'level',
    domain: 'domains',
    category: 'categories',
    instructor_id: 'instructors',
    language_type: 'languages',
    sub_category: 'subcategories',
    subCategory: 'subcategories',
    pricing_type: 'isFree',
    search: 'text',
    tag: 'hashTag',
    categorySlug: 'filterConfigSlug',
  };

  const generatePayloadFromQuery = () => {
    const payload = {
      level: '',
      programType: '',
      text: '',
      instructors: [],
      categories: [],
      languages: [],
      subcategories: [],
      domains: [],
      isFree: '',
      hashTag: [],
      filterConfigSlug: '',
    };
    const queryObject = router.query;

    Object.keys(queryObject).forEach((key) => {
      if (key === 'page') return;
      const payloadKey = payloadLabel[key];
      const queryObjectValue = queryObject[key];
      if (Array.isArray(payload[payloadKey])) {
        if (Array.isArray(queryObjectValue)) {
          (payload[payloadKey] as string[]) = queryObjectValue;
        } else if (queryObjectValue) {
          (payload[payloadKey] as string[]).push(queryObjectValue);
        }
      } else if (payloadKey === 'text') {
        payload[payloadKey] = queryObjectValue as string;
      } else (payload[payloadKey] as string) = queryObjectValue as string;
    });
    return payload;
  };

  // const getIsCourseBought = async () => {
  //   try {
  //     const courseBoughtResponse = await CourseDescription.isCourseBought(courseDetails?._id || '');
  //     if (courseBoughtResponse?.data) {
  //       setIsCourseBought(true);
  //     }
  //   } catch (error: unknown) {
  //     setIsCourseBought(false);
  //     // eslint-disable-next-line no-console
  //     // console.error((error as IError)?.error);
  //   }
  // };
  const handleGetOtp = async () => {
    otpAttemptCountRef.current += 1;
    const otpCohortId =
      typeof courseDetails?.cohortId === 'string'
        ? courseDetails?.cohortId
        : courseDetails?.cohortId?._id || '';
    const otpPrice = courseDetails?.pricing?.IN ?? courseDetails?.pricing?.US;
    const otpDiscount = courseDetails?.pricing?.discount;
    const otpIsFree = courseDetails?.pricing?.isFree;

    sendSkOtpRequestInitiatedEvent({
      isLoggedIn,
      form_id:
        leadCaptureType === LeadCaptureType.MODAL ? 'lead_capture_modal' : 'lead_capture_form',
      form_name:
        leadCaptureType === LeadCaptureType.MODAL ? 'Lead Capture Modal' : 'Lead Capture Form',
      form_type: 'lead',
      form_location: router.pathname,
      cta_text: 'GET OTP',
      otp_channel: 'sms',
      request_type: 'first_request',
      otp_attempt_number: otpAttemptCountRef.current,
      resend_count: otpResendCountRef.current,
      user_phone_number: contactDetails.phoneNumber,
      user_phone_isd_code: contactDetails.isdCode,
      course_batch_name: courseName || courseDetails?.title,
      course_batch_slug: (courseDetails as any)?.slug,
      course_batch_category: categoryName || courseDetails?.categoryDetails?.title,
      course_batch_id: courseId || courseDetails?._id,
      course_batch_cohort_id: otpCohortId || undefined,
      price: typeof otpPrice === 'number' ? otpPrice : undefined,
      discount_percentage: typeof otpDiscount === 'number' ? otpDiscount : undefined,
      is_free: typeof otpIsFree === 'boolean' ? otpIsFree : undefined,
      platform: 'web',
    });

    const userData = {
      username: contactDetails.phoneNumber,
      countryCode: contactDetails.isdCode,
      organizationId: `${getPPClientDetails()?.clientId || penPencilClientId}`,
      firstName: contactDetails.fullName,
      lastName: '',
      captchaToken,
      captchaSiteKey: captchaConfig?.siteKey,
    };
    try {
      const smsType = contactDetails.isdCode !== '+91' ? SMS_TYPE : '0';
      setCurrentTimerCount(INITIAL_TIMER_COUNT);
      const response = await LeadCaptureApi.getOtp(userData, {
        smsType,
        sourceName,
        isCaptchaEnabled,
      });
      if (response) {
        setIsOtpSent(true);
        setOtp('');
        resetCaptchaIfEnabled();
      }
    } catch (error: any) {
      // console.log(err)
      if (error?.error?.status === 400) {
        setIsOtpSent(true);
        setOtp('');
        resetCaptchaIfEnabled();
      }
    }
  };

  const renderInput = () => {
    return (
      <Input
        id={leadCaptureType === LeadCaptureType.MODAL ? 'name' : 'name_input_field'}
        wrapperClass="mt-5"
        label={leadCaptureType === LeadCaptureType.MODAL ? 'Enter Your Full Name' : 'Name'}
        name="fullName"
        value={contactDetails.fullName}
        onChange={(nameData) => {
          handleChange(nameData);
          setIsError({ ...isError, nameError: false });
        }}
        error={isError.nameError}
        helperText={(isError.nameError && isName(contactDetails.fullName)) || ''}
        isRequired
        disabled={isLoggedIn}
      />
    );
  };

  const renderPhoneNumber = () => {
    return (
      <div className="flex items-end !w-full">
        <div
          className="!w-full"
          id={leadCaptureType === LeadCaptureType.MODAL ? 'phoneNumber' : 'phoneNumber_input_field'}
        >
          <MobileInput
            // id="get_in_touch_phoneNumber"
            autoFocus={false}
            disabled={isLoggedIn}
            defaultCountry="IN"
            wrapperClass="mt-5 flex !flex-grow !w-full [&>div]:!w-full"
            className="w-full"
            countrySearch
            error={isError.phoneNumberError}
            helperText={
              (isError.phoneNumberError &&
                isValidIndianPhoneNumber(contactDetails.phoneNumber, contactDetails.isdCode)) ||
              ''
            }
            onChange={(e) => {
              setContactDetails({ ...contactDetails, phoneNumber: e });
              setIsError({ ...isError, phoneNumberError: false });
            }}
            isValid={(val) => {
              setIsValidPhoneNumber(val);
              if (val && isOtpSent) {
                setIsOtpSent(false);
                setIsOtpVerified(false);
              }
            }}
            value={contactDetails.phoneNumber}
            countryCode={(val) => setContactDetails({ ...contactDetails, isdCode: val })}
          />
        </div>
      </div>
    );
  };

  const renderOtpButton = (options?: { captchaToken?: string; isCaptchaEnabled?: boolean }) => {
    const handleOtpClick = () => {
      if (options?.isCaptchaEnabled && !options?.captchaToken) {
        toast.error('Please complete the captcha verification');
        return;
      }
      handleGetOtp();
    };

    const isDisabled = !isValidPhoneNumber || isOtpSent || !isValidName;

    return (
      <button
        type="button"
        disabled={isDisabled}
        onClick={handleOtpClick}
        className={`w-fit text-base font-semibold whitespace-nowrap border-b border-stroke-300 ${
          isLoggedIn || isDisabled ? '!text-orange-100' : '!text-orange-500'
        } p-1 `}
      >
        {isOtpSent ? 'OTP Sent' : 'GET OTP'}
      </button>
    );
  };

  const handleResendOtp = async () => {
    otpResendCountRef.current += 1;
    otpAttemptCountRef.current += 1;
    const resendCohortId =
      typeof courseDetails?.cohortId === 'string'
        ? courseDetails?.cohortId
        : courseDetails?.cohortId?._id || '';
    const resendPrice = courseDetails?.pricing?.IN ?? courseDetails?.pricing?.US;
    const resendDiscount = courseDetails?.pricing?.discount;
    const resendIsFree = courseDetails?.pricing?.isFree;

    sendSkOtpRequestInitiatedEvent({
      isLoggedIn,
      form_id:
        leadCaptureType === LeadCaptureType.MODAL ? 'lead_capture_modal' : 'lead_capture_form',
      form_name:
        leadCaptureType === LeadCaptureType.MODAL ? 'Lead Capture Modal' : 'Lead Capture Form',
      form_type: 'lead',
      form_location: router.pathname,
      cta_text: 'Resend OTP',
      otp_channel: 'sms',
      request_type: 'resend',
      otp_attempt_number: otpAttemptCountRef.current,
      resend_count: otpResendCountRef.current,
      user_phone_number: contactDetails.phoneNumber,
      user_phone_isd_code: contactDetails.isdCode,
      course_batch_name: courseName || courseDetails?.title,
      course_batch_slug: (courseDetails as any)?.slug,
      course_batch_category: categoryName || courseDetails?.categoryDetails?.title,
      course_batch_id: courseId || courseDetails?._id,
      course_batch_cohort_id: resendCohortId || undefined,
      price: typeof resendPrice === 'number' ? resendPrice : undefined,
      discount_percentage: typeof resendDiscount === 'number' ? resendDiscount : undefined,
      is_free: typeof resendIsFree === 'boolean' ? resendIsFree : undefined,
      platform: 'web',
    });

    setIsOtpVerified(null);
    const dataToBeSend = {
      mobile: contactDetails.phoneNumber,
      organizationId: `${getPPClientDetails()?.clientId || penPencilClientId}`,
      captchaToken,
      captchaSiteKey: captchaConfig?.siteKey,
    };
    try {
      const smsType = contactDetails.isdCode !== '+91' ? SMS_TYPE : '0';
      setCurrentTimerCount(INITIAL_TIMER_COUNT);
      const response = await LeadCaptureApi.resendOtp(dataToBeSend, smsType, isCaptchaEnabled);
      if (response) {
        setIsOtpSent(true);
        setOtp('');
        resetCaptchaIfEnabled();
      }
    } catch (error: any) {
      if (error?.response?.status === 400) {
        setIsOtpSent(true);
        setOtp('');
        resetCaptchaIfEnabled();
      }
    }
  };

  const getFilteredCourseData = async (pageNumber: number) => {
    setIsLoading(true);

    const filterSearchPayload = generatePayloadFromQuery();
    setPageNo(pageNumber);
    // const pageNumber = Number.isNaN(router.query.page) ? -1 : router.query.page;

    try {
      const payload = {
        ...filterSearchPayload,
        filterConfigSlug: categorySlug,
        filterConfigSrc: 'category_page',
      };

      const response = await CourseListingApi.getFilteredCourse(
        payload as IFilterApiPayload,
        Number(pageNumber)
      );

      if (response) {
        const responseData = response?.data;
        setTotalPages(responseData?.meta[0]?.metadata[0]?.totalPages);
        if (responseData.courses.length > 0) {
          // setCoursesDetails(responseData?.courses);
          setDropDownOptions((prevOptions) => {
            const newOptions = responseData.courses.map((course) => course);
            return [...prevOptions, ...newOptions];
          });
        }
      }
      setIsLoading(false);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const isResendDisabled = useMemo(() => {
    return currentTimerCount > 0;
  }, [currentTimerCount]);

  const handleDropDownOpen = () => {
    setDropDownOpen(!dropDownOpen);
  };

  const handleBackgroundDropDownOpen = () => {
    setDropDownBackground(!dropDownBackground);
  };

  const handleWorkExperienceDropDownOpen = () => {
    setDropDownWorkExperience(!dropDownWorkExperience);
  };

  const handleSelectedDropdownOption = (option: string) => {
    setSelectedDropdownOption(option);
    handleDropDownOpen();
  };

  const handleBlur = (e: React.FocusEvent<HTMLDivElement, Element>) => {
    const { currentTarget } = e;
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement)) {
        if (dropDownOpen) handleDropDownOpen();
        if (dropDownBackground) handleBackgroundDropDownOpen();
        if (dropDownWorkExperience) handleWorkExperienceDropDownOpen();
        // if (showDeleteModal) setShowDeleteModal(false);
      }
    });
  };

  const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    // Allow only digits
    if (/^\d*$/.test(input)) {
      // Allow only up to 4 digits
      if (input.length <= 4) {
        setOtp(input);
      }
    }
  };

  const renderOtpField = () => {
    return (
      <div className="flex flex-col gap-1">
        <div className="flex items-end">
          <Input
            id={leadCaptureType === LeadCaptureType.MODAL ? 'otp' : 'otp_input_field'}
            type="text"
            value={otp}
            disabled={!isValidPhoneNumber || !isOtpSent}
            onChange={(e) => {
              handleOtpChange(e);
            }}
            className="!w-full"
            wrapperClass="mt-5 flex !flex-grow !w-full [&>div]:!w-full"
            label="OTP"
          />

          {isOtpSent &&
            (isResendDisabled ? (
              <Typography
                variant="bold"
                component="body-tiny"
                className="text-orange-500 w-fit font-semibold whitespace-nowrap border-b border-stroke-300"
              >
                00:
                {currentTimerCount.toLocaleString('en-IN', {
                  minimumIntegerDigits: 2,
                })}
              </Typography>
            ) : (
              <button
                type="button"
                disabled={!isValidPhoneNumber && isOtpSent}
                onClick={() => {
                  // handleGetOtp();
                  handleResendOtp();
                }}
                className={`w-fit font-bold whitespace-nowrap border-b border-stroke-300 ${
                  currentTimerCount !== 0 && (!isValidPhoneNumber || isOtpSent)
                    ? '!text-orange-100'
                    : '!text-orange-500'
                } p-1 text-[12px]`}
              >
                Resend OTP
              </button>
            ))}
        </div>
        {isOtpSent && !isOtpVerified && isOtpVerified !== null && (
          <Typography variant="semi-bold" component="body-tiny" className="!text-red-500">
            *Invalid OTP{' '}
          </Typography>
        )}
      </div>
    );
  };

  const renderEmailField = () => {
    return (
      <Input
        id={leadCaptureType === LeadCaptureType.MODAL ? 'email' : 'email_input_field'}
        wrapperClass="mt-5"
        label="Email"
        name="email"
        value={contactDetails.email}
        error={isError.emailError}
        helperText={
          (isError.emailError && isEmail((contactDetails.email && contactDetails?.email) || '')) ||
          ''
        }
        onChange={(emailData) => {
          handleChange(emailData);
          setIsError({ ...isError, emailError: false });
        }}
        isRequired
        disabled={isLoggedIn && user.email !== undefined}
      />
    );
  };

  const handleSelectedBackground = (option: string) => {
    setSelectedBackground(option);
    if (option === BackgroundFormItem.COLLEGE_STUDENT) {
      setSelectedWorkExperience(''); // Clear work experience if the selected background is one of the specified options
    }

    handleBackgroundDropDownOpen();
  };

  const handleSelectedWorkExperience = (option: string) => {
    setSelectedWorkExperience(option);
    handleWorkExperienceDropDownOpen();
  };

  const renderBackgroundDropDown = () => {
    return (
      <div className="relative mt-5" onBlur={handleBlur}>
        <button
          type="button"
          onClick={handleBackgroundDropDownOpen}
          className="border-b-[1px] border-b-solid border-stroke-300  text-left !w-full"
        >
          <div className="py-2 inline-flex flex-row gap-x-1 !rounded !w-full !justify-between">
            <input
              id={
                leadCaptureType === LeadCaptureType.MODAL
                  ? 'background_dropdown'
                  : 'background_dropdown_form'
              }
              type="text"
              value={selectedBackground}
              className="!hidden"
            />
            <Typography
              variant="regular"
              component="body-regular"
              className={`${
                selectedBackground.length === 0 ? 'text-[#757575] ' : ''
              } font-sans-serif`}
            >
              {selectedBackground.length === 0 ? 'Select Background' : selectedBackground}
            </Typography>
            <Image src={downArrow} alt="downArrow" width={12} height={12} />
          </div>
        </button>
        {dropDownBackground && (
          <div className="flex flex-col absolute top-[42px] left-0 z-10 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.06)] !w-full max-h-[180px] overflow-y-auto">
            {dropdownBackgroundOptions?.map((dropdown, index) => {
              return (
                <button
                  key={randomId()}
                  type="button"
                  onClick={() => {
                    // setSelectedDropdownCourseId(dropdown._id);
                    handleSelectedBackground(dropdown.title);
                  }}
                >
                  <div
                    onBlur={handleBlur}
                    className={`flex flex-row  px-4 py-2 gap-x-2 bg-[#f8f8f8] ${
                      dropdownBackgroundOptions.length - 1 === index ? 'rounded-b' : 'rounded-t'
                    } ${
                      index === 0
                        ? 'border-t-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-t-[#EFEFEF]  !rounded-t'
                        : index === dropdownBackgroundOptions.length - 1
                        ? 'border-y-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-y-[#EFEFEF] !rounded-b'
                        : 'border-t-[1px] border-x-[1px] border-t-solid border-x-solid border-x-[#EFEFEF] border-t-[#EFEFEF] '
                    } hover:bg-[#F8F8F8]`}
                  >
                    <Typography
                      variant="regular"
                      component="body-small"
                      className=" text-[14px] leading-[22px] text-[#2F2F2F] w-[158px] self-center !text-start"
                    >
                      {dropdown.title}
                    </Typography>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const renderWorkExperienceDropDown = () => {
    return (
      <div className="relative mt-5" onBlur={handleBlur}>
        <button
          type="button"
          onClick={handleWorkExperienceDropDownOpen}
          className="border-b-[1px] border-b-solid border-stroke-300  text-left !w-full"
          disabled={selectedBackground.includes(BackgroundFormItem.COLLEGE_STUDENT)}
        >
          <div className="py-2 inline-flex flex-row gap-x-1 !rounded !w-full !justify-between">
            <input
              id={
                leadCaptureType === LeadCaptureType.MODAL
                  ? 'work_experience_dropdown'
                  : 'work_experience_dropdown_form'
              }
              type="text"
              value={selectedWorkExperience}
              className="!hidden"
            />
            <Typography
              variant="regular"
              component="body-regular"
              className={`${
                selectedWorkExperience.length === 0 ? 'text-[#757575] ' : ''
              } font-sans-serif ${
                selectedBackground.includes(BackgroundFormItem.COLLEGE_STUDENT)
                  ? 'text-gray-400'
                  : ''
              }`}
            >
              {selectedWorkExperience.length === 0 ? 'Work Experience' : selectedWorkExperience}
            </Typography>
            <Image src={downArrow} alt="downArrow" width={12} height={12} />
          </div>
        </button>
        {dropDownWorkExperience && (
          <div className="flex flex-col absolute top-[42px] left-0 z-10 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.06)] !w-full max-h-[180px] overflow-y-auto">
            {dropDownWorkExOptions?.map((dropdown, index) => {
              return (
                <button
                  key={randomId()}
                  type="button"
                  onClick={() => {
                    // setSelectedDropdownCourseId(dropdown._id);
                    handleSelectedWorkExperience(dropdown.title);
                  }}
                >
                  <div
                    onBlur={handleBlur}
                    className={`flex flex-row  px-4 py-2 gap-x-2 bg-[#f8f8f8] ${
                      dropDownWorkExOptions.length - 1 === index ? 'rounded-b' : 'rounded-t'
                    } ${
                      index === 0
                        ? 'border-t-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-t-[#EFEFEF]  !rounded-t'
                        : index === dropDownWorkExOptions.length - 1
                        ? 'border-y-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-y-[#EFEFEF] !rounded-b'
                        : 'border-t-[1px] border-x-[1px] border-t-solid border-x-solid border-x-[#EFEFEF] border-t-[#EFEFEF] '
                    } hover:bg-[#F8F8F8]`}
                  >
                    <Typography
                      variant="regular"
                      component="body-small"
                      className=" text-[14px] leading-[22px] text-[#2F2F2F] w-[158px] self-center !text-start"
                    >
                      {dropdown.title}
                    </Typography>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const renderSelectProgramDropdown = () => {
    return (
      <div className="relative mt-5" onBlur={handleBlur}>
        <button
          type="button"
          onClick={handleDropDownOpen}
          className="border-b-[1px] border-b-solid border-stroke-300  text-left !w-full"
        >
          <div className="py-2 inline-flex flex-row gap-x-1 !rounded !w-full !justify-between">
            <Typography
              variant="regular"
              component="body-regular"
              className={`${
                selectedDropdownOption.length === 0 ? 'text-[#757575] ' : ''
              } font-sans-serif`}
            >
              {selectedDropdownOption.length === 0 ? 'Select Program' : selectedDropdownOption}
            </Typography>
            <Image src={downArrow} alt="downArrow" width={12} height={12} />
          </div>
        </button>
        {dropDownOpen && (
          <div
            className="flex flex-col absolute top-[42px] left-0 z-10 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.06)] !w-full max-h-[180px] overflow-y-auto"
            onScroll={(event) => {
              const target = event.target as HTMLElement;
              const scrollPercentage =
                (target.scrollTop / (target.scrollHeight - target?.clientHeight)) * 100;

              if (scrollPercentage >= 50 && !isLoading && pageNo < totalPages) {
                getFilteredCourseData(pageNo + 1);
              }
            }}
          >
            {dropdownOptions?.map((dropdown, index) => {
              return (
                <button
                  key={randomId()}
                  type="button"
                  onClick={() => {
                    setSelectedDropdownCourseId(dropdown._id);
                    handleSelectedDropdownOption(dropdown.title);
                  }}
                >
                  <div
                    onBlur={handleBlur}
                    className={`flex flex-row  px-4 py-2 gap-x-2 bg-[#f8f8f8] ${
                      dropdownOptions.length - 1 === index ? 'rounded-b' : 'rounded-t'
                    } ${
                      index === 0
                        ? 'border-t-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-t-[#EFEFEF]  !rounded-t'
                        : index === dropdownOptions.length - 1
                        ? 'border-y-[1px] border-x-[1px] border-solid border-x-[#EFEFEF] border-y-[#EFEFEF] !rounded-b'
                        : 'border-t-[1px] border-x-[1px] border-t-solid border-x-solid border-x-[#EFEFEF] border-t-[#EFEFEF] '
                    } hover:bg-[#F8F8F8]`}
                  >
                    <Typography
                      variant="regular"
                      component="body-small"
                      className=" text-[14px] leading-[22px] text-[#2F2F2F] w-[158px] self-center !text-start"
                    >
                      {dropdown.title}
                    </Typography>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  function areContactDetailsValid() {
    return (
      contactDetails.fullName.trim().length >= 2 &&
      contactDetails.isdCode &&
      contactDetails.phoneNumber &&
      isValidPhoneNumber
    );
  }

  const disabled = useMemo(() => {
    const isBackgroundWithoutWorkEx =
      selectedBackground.includes(BackgroundFormItem.COLLEGE_STUDENT) ||
      selectedBackground.includes(BackgroundFormItem.GRADUATE);

    const additionalConditions =
      modalType === ModalType.ONLINE_DEGREE
        ? isBackgroundWithoutWorkEx
          ? selectedBackground && contactDetails.email
          : selectedBackground && selectedWorkExperience && contactDetails.email
        : modalType === ModalType.CATEGORY_PAGE_FORM
        ? selectedDropdownOption
        : true;

    const baseConditions = areContactDetailsValid() && additionalConditions;

    if (isLoggedIn) {
      return !baseConditions;
    }
    return !(baseConditions && otp);
  }, [
    contactDetails.fullName,
    contactDetails.isdCode,
    contactDetails.phoneNumber,
    isValidPhoneNumber,
    isLoggedIn,
    otp,
    selectedBackground,
    selectedDropdownOption,
    selectedWorkExperience,
    contactDetails.email,
  ]);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return '';
    }

    try {
      const token = await executeRecaptcha(randomId());
      return token;
    } catch (error) {
      return '';
    }
  }, [executeRecaptcha]);

  const closeModal = () => {
    setSaving(false);
    if (setModelOpen) {
      setModelOpen(false);
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (isLoggedIn) {
      setContactDetails({
        ...contactDetails,
      });
      setSelectedDropdownOption('');
      setSelectedBackground('');
      setSelectedWorkExperience('');
      setCount(AUTO_CLOSE_TIME / 1000);
    } else {
      setContactDetails({
        ...contactDetails,
        fullName: '',
        email: '',
        isdCode: '+91',
        phoneNumber: '',
      });
    }
    setIsError({ nameError: false, emailError: false, phoneNumberError: false });
  };

  function getEventDataObj(data: ContactDetails, eventType: string) {
    const commonData = {
      user_id: user?._id || '',
      user_type: isLoggedIn ? 'loggedin' : 'not_loggedin',
      course_status: isLoggedIn && isCourseBought ? 'purchased' : 'not_purchased',
      user_category: user?.userType || '',
      enquiry_type: enquiryType,
      ...(eventType === 'MO' && {
        phone_number: data.phoneNumber || '',
        username: `${user?.firstName} ${user?.lastName}` || '',
        ...(user?.verified && user?.email && { email: user.email }),
      }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        student_background: selectedBackground,
        work_experience: selectedWorkExperience,
        courseType: 'online degree',
      }),
      ...(eventType === 'GA' && {
        page_name: pageName,
        form_id:
          leadCaptureType === LeadCaptureType.FORM
            ? `${enquiryType}_form_input_field`
            : `${enquiryType}_form`,
      }),
    };

    if (leadCaptureType === LeadCaptureType.MODAL) {
      return {
        ...commonData,
        course_name: courseName || (courseDetails && courseDetails?.batchName),
        course_id: courseId || (courseDetails && courseDetails._id),
        category_name: categoryName || (courseDetails && courseDetails?.categoryDetails?.name),
        category_id: categoryId || (courseDetails && courseDetails?.categoryDetails?._id),
      };
    }
    return {
      ...commonData,
      course_name: selectedDropdownOption,
      course_id: selectedDropdownCourseId,
      category_name: categoryDetails?.title,
      category_id: categoryDetails?._id,
    };
  }

  function getUserPseudoId() {
    const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));

    if (gaCookie) {
      const gaParts = gaCookie.split('.');
      if (gaParts.length > 2) {
        return `${gaParts[2]}.${gaParts[3]}`;
      }
    }

    return null;
  }

  const getCourseContextForEvent = () => {
    if (leadCaptureType === LeadCaptureType.MODAL) {
      return {
        courseNameValue: courseDetails?.batchName || '',
        courseIdValue: courseDetails?._id || '',
        courseCategoryValue: courseDetails?.categoryDetails?.name || categoryDetails?.title || '',
        courseSlug: courseDetails?.slug || '',
        cohortId:
          typeof courseDetails?.cohortId === 'string'
            ? courseDetails?.cohortId
            : courseDetails?.cohortId?._id || '',
        price: courseDetails?.pricing?.IN || courseDetails?.pricing?.US || 0,
        discount: courseDetails?.pricing?.discount || 0,
        isFree: courseDetails?.pricing?.isFree || false,
      };
    }

    return {
      courseNameValue: selectedDropdownOption || courseName || '',
      courseIdValue: selectedDropdownCourseId || courseId || '',
      courseCategoryValue: categoryDetails?.title || categoryName || '',
    };
  };

  const getUserSegmentForAnalytics = () => {
    if (isLoggedIn) {
      return 'returning_user';
    }
    return 'new';
  };

  const triggerSkFormSubmittedEvent = () => {
    const {
      courseNameValue,
      courseIdValue,
      courseCategoryValue,
      courseSlug,
      cohortId,
      price,
      discount,
      isFree,
    } = getCourseContextForEvent();
    const courseOfInterest =
      leadCaptureType === LeadCaptureType.MODAL
        ? courseNameValue
        : selectedDropdownOption || courseNameValue;
    const pagePath = router?.asPath || '';
    const formLocation = pageName || router?.pathname || 'lead_capture';
    const ctaLabel = typeof buttonText === 'string' ? buttonText : '';
    const pageReferrerCta = ctaLabel || (type ? String(type) : '');
    const widgetName = sourceName || enquiryType || '';
    const userPseudoId = getUserPseudoId() || '';
    const sanitizedFullName = contactDetails.fullName?.trim();
    const sanitizedEmail = contactDetails.email?.trim();
    const sanitizedPhoneNumber = contactDetails.phoneNumber?.trim();
    const sanitizedIsdCode = contactDetails.isdCode?.trim();

    sendSkFormSubmittedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid: isCourseBought,
      user_account_type: user?.userType,
      page_path: pagePath,
      page_referrer_name: pageName || '',
      page_referrer_cta: pageReferrerCta,
      page_referrer_widget_name: widgetName,
      user_pseudo_id: userPseudoId,
      pw_user_id: user?._id,
      user_segment: getUserSegmentForAnalytics(),
      form_id: 'lead_form_da',
      form_name: `${courseCategoryValue} lead form`,
      form_type: 'lead',
      form_location: formLocation,
      background: selectedBackground || '',
      work_experience: selectedWorkExperience || undefined,
      course_of_interest: courseOfInterest || '',
      domain: courseCategoryValue || '',
      course_name: courseNameValue || '',
      course_category: courseCategoryValue || '',
      course_id: courseIdValue || '',
      course_slug: courseSlug || '',
      cohort_id: cohortId || '',
      price: price || 0,
      discount: discount || 0,
      is_free: isFree || false,
      user_name: sanitizedFullName || undefined,
      user_email: sanitizedEmail || undefined,
      user_phone_number: sanitizedPhoneNumber || undefined,
      user_phone_isd_code: sanitizedIsdCode || undefined,
      name: sanitizedFullName || undefined,
      email: sanitizedEmail || undefined,
      phone_number: sanitizedPhoneNumber || undefined,
    });
  };

  useEffect(() => {
    if (leadCaptureType !== LeadCaptureType.MODAL || !modelOpen || skFormStartedTrackedRef.current)
      return;

    const courseNameValue = courseDetails?.batchName || '';
    const courseIdValue = courseDetails?._id || '';
    const courseCategoryValue =
      courseDetails?.categoryDetails?.name || categoryDetails?.title || '';
    const courseSlug = courseDetails?.slug || '';
    const cohortId =
      typeof courseDetails?.cohortId === 'string'
        ? courseDetails?.cohortId
        : courseDetails?.cohortId?._id || '';
    const price = courseDetails?.pricing?.IN || courseDetails?.pricing?.US || 0;
    const discount = courseDetails?.pricing?.discount || 0;
    const isFree = courseDetails?.pricing?.isFree || false;

    const formLocation = pageName || router?.pathname || 'lead_capture';
    const ctaLabel = typeof buttonText === 'string' ? buttonText : '';
    const pageReferrerCta = ctaLabel || (type ? String(type) : 'lead_form_start');
    const widgetName = sourceName || enquiryType || '';

    sendSkFormStartedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid: isCourseBought,
      user_account_type: user?.userType,
      page_path: router?.asPath || '',
      page_referrer_name: pageName || '',
      page_referrer_cta: pageReferrerCta,
      page_referrer_widget_name: widgetName,
      user_pseudo_id: getUserPseudoId() || undefined,
      pw_user_id: user?._id,
      user_segment: isLoggedIn ? 'returning_user' : 'new',
      form_id: 'lead_form_da',
      form_name: `${courseCategoryValue || 'course'} lead form`,
      form_type: 'lead',
      form_location: formLocation,
      form_total_fields: 3,
      form_time_fill_sec: 0,
      course_batch_name: courseNameValue || undefined,
      course_batch_slug: courseSlug || undefined,
      course_batch_category: courseCategoryValue || undefined,
      course_batch_id: courseIdValue || undefined,
      course_batch_cohort_id: cohortId || undefined,
      price: price || undefined,
      discount_percentage: discount || undefined,
      is_free: isFree || undefined,
    });

    skFormStartedTrackedRef.current = true;
  }, [
    buttonText,
    enquiryType,
    isCourseBought,
    isLoggedIn,
    leadCaptureType,
    modelOpen,
    pageName,
    categoryDetails?.title,
    courseDetails?._id,
    courseDetails?.batchName,
    courseDetails?.categoryDetails?.name,
    courseDetails?.cohortId,
    courseDetails?.pricing?.IN,
    courseDetails?.pricing?.US,
    courseDetails?.pricing?.discount,
    courseDetails?.pricing?.isFree,
    courseDetails?.slug,
    router?.asPath,
    router?.pathname,
    sourceName,
    type,
    user,
  ]);

  function getObjDataDb(data: ContactDetails): IObjDataDb {
    const dbData: IObjDataDb = {
      ...(isLoggedIn && { user_id: user?._id }),
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      phone_number: data.phoneNumber || '',
      username: `${user?.firstName} ${user?.lastName}` || '',
      ...(user?.verified && user?.email && { email: user.email }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        background: selectedBackground,
        experience: selectedWorkExperience,
      }),
      page_name: pageName,
      ...(!isLoggedIn && { user_pseudo_id: getUserPseudoId() || undefined }),
      date_time: new Date().toISOString(),
    };

    if (leadCaptureType === LeadCaptureType.MODAL) {
      return {
        ...dbData,
        course_name: courseName || (courseDetails && courseDetails?.title),
        course_id: courseId || (courseDetails && courseDetails._id),
        category_name: categoryName || (courseDetails && courseDetails?.categoryDetails?.title),
        category_id: categoryId || (courseDetails && courseDetails?.categoryDetails?._id),
        enquiry_type: enquiryType,
      };
    }
    return {
      ...dbData,
      course_name: selectedDropdownOption,
      course_id: selectedDropdownCourseId,
      category_name: categoryDetails?.title,
      category_id: categoryDetails?._id,
      enquiry_type: enquiryType,
    };
  }

  const sendDataToDB = async (data: ContactDetails) => {
    const objData = getObjDataDb(data);
    try {
      await LeadCaptureApi.sendDataToDatabase(objData);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
    }
  };

  const sendLead = async (data: ContactDetails) => {
    const token = await handleReCaptchaVerify();
    const GAEventDataObj = getEventDataObj(data, 'GA');
    GAevent('sk_form_submit', GAEventDataObj);
    sendDataToDB(data);

    try {
      if (isLoggedIn) {
        const moEventData = getEventDataObj(data, 'MO');

        if (modalType === ModalType.ONLINE_DEGREE) {
          moEvent('online_degree_course_enquiry', moEventData);
        } else {
          moEvent('course_enquiry_request', moEventData);
        }
      }

      if (modalType === ModalType.CATEGORY_PAGE_FORM) {
        await CategoryPageApi.categoryEnquiry(categoryDetails?._id as string, token, data);
      } else if (categoryId) {
        await CategoryPageApi.categoryEnquiry(categoryId as string, token, data);
      } else if (courseId && modalType !== ModalType.ONLINE_DEGREE) {
        await CourseDescription.courseEnquiry(courseId as string, token, data);
      } else {
        await OnlineDegreePageApi.onlineDegreeEnquiry(token, data);
      }

      // handleDownload();
    } catch (error: unknown) {
      // setApiErrorMessage((error as IError)?.error || 'Something went wrong!');
      // setApiError(true);
    } finally {
      // handleDownload();
    }
  };

  const handleDownload = async () => {
    const dataToSend = {
      username: contactDetails.phoneNumber,
      otp,
      organizationId: `${getPPClientDetails()?.clientId || penPencilClientId}`,
      grant_type: `${getPPClientDetails()?.clientType || penPencilTokenGrantType}`,
      client_id: `${penPencilTokenClientId}`,
      client_secret: `${penPencilTokenClientSecret}`,
    };

    const leadData = {
      // ...contactDetails,
      fullName: contactDetails.fullName,
      ...(modalType === ModalType.ONLINE_DEGREE && { email: contactDetails.email }),
      isdCode: contactDetails.isdCode,
      phoneNumber: contactDetails.phoneNumber,
      source: utmQuery?.utm_source,
      medium: utmQuery?.utm_medium,
      campaign: utmQuery?.utm_campaign,
      adGroupId: utmQuery?.utm_adgroupid,
      adGroup: utmQuery?.utm_adgroup,
      adSet: utmQuery?.utm_adset,
      content: utmQuery?.utm_content,
      term: utmQuery?.utm_term,
      placement: utmQuery?.utm_placement,
      gclid: utmQuery?.gclid,
      fbclid: utmQuery?.fbclid,
      mown: utmQuery?.mown,
      obj: utmQuery?.obj,
      at: utmQuery?.at,
      sch: utmQuery?.sch,
      lpt: utmQuery?.lpt,
      cred: utmQuery?.cred,
      cat: utmQuery?.cat,
      enquiryType: enquiryTypeNPF,
      ...(modalType === ModalType.CATEGORY_PAGE_FORM && { category_name: categoryDetails?.title }),
      ...(modalType === ModalType.CATEGORY_PAGE_FORM && { course_new: selectedDropdownOption }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        field_student_background: selectedBackground,
      }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        field_work_experience: selectedWorkExperience,
      }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        course_new: courseName || (courseDetails && courseDetails?.title),
      }),
      ...(modalType === ModalType.ONLINE_DEGREE && {
        field_course_type: 'online_degree',
        field_college_name:
          collegeName ||
          (courseDetails &&
            courseDetails?.partnerInstituteDetails &&
            courseDetails?.partnerInstituteDetails[0]?.name),
        field_website_page_visit: 'Online Degree', // added this for online degree modal and forms
      }),
    };

    if (!isLoggedIn) {
      try {
        // setCurrentTimerCount(13);
        const response = await LeadCaptureApi.getPPToken(dataToSend);
        if (response) {
          setSaving(true);

          if (leadCaptureType === LeadCaptureType.FORM) {
            setDialogOpen(true);
            setContactDetails({ fullName: '', email: '', isdCode: '+91', phoneNumber: '' });
            setSelectedBackground('');
            setSelectedDropdownOption('');
            setOtp('');
            setSelectedWorkExperience('');
            setIsOtpSent(false);
          }

          setTimeout(() => {
            closeModal();
          }, AUTO_CLOSE_TIME);
          sendLead(leadData);
          if (
            type === LeadType.DOWNLOAD_CURRICULUM ||
            type === LeadType.DOWNLOAD_PLACEMENT_REPORT ||
            type === LeadType.DOWNLOAD_BROCHURE
          ) {
            anchorRef?.current?.click();
          }
          setContactDetails({ fullName: '', email: '', isdCode: '', phoneNumber: '' });
          setTimeout(() => {
            if (window && redirectLink) {
              window.open(redirectLink, '_blank');
            }
          }, 5000);
        }
      } catch (error: any) {
        // console.log(err)
        setIsOtpVerified(false);
      }
    } else {
      // send lead on button click
      if (leadCaptureType === LeadCaptureType.FORM) {
        setDialogOpen(true);
      }
      sendLead(leadData);
      setSaving(true);
      if (
        type === LeadType.DOWNLOAD_CURRICULUM ||
        type === LeadType.DOWNLOAD_PLACEMENT_REPORT ||
        type === LeadType.DOWNLOAD_BROCHURE
      ) {
        anchorRef?.current?.click();
      }
      setCount(AUTO_CLOSE_TIME / 1000);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current); // Clear any existing timeout
      }
      timeoutRef.current = setTimeout(() => {
        closeModal();
        if (window && redirectLink) {
          setTimeout(() => {
            window.open(redirectLink, '_blank');
          }, 1000);
        }
      }, AUTO_CLOSE_TIME);
    }
  };

  const handleSubmit = async () => {
    // setTimeout(() => {
    //   if (otp === OTP) {
    //     setSaving(true);
    //     setIsOtpVerified(true);
    //     // console.log('truee');
    //     handleDownload();
    //   } else {
    //     setIsOtpVerified(false);
    //     // console.log('faled');
    //   }
    // }, 1000);
    sendGAEvent('sk_form_submit');
    triggerSkFormSubmittedEvent();
    if (
      !isName(contactDetails.fullName) &&
      !isEmail((contactDetails.email && contactDetails?.email) || '') &&
      !isValidIndianPhoneNumber(contactDetails.phoneNumber, contactDetails.isdCode)
    ) {
      // sendLead(data);
      handleDownload();
    } else {
      setIsError({
        ...isError,
        nameError: !!isName(contactDetails.fullName),
        emailError: !!isEmail((contactDetails.email && contactDetails?.email) || ''),
        phoneNumberError: !!isValidIndianPhoneNumber(
          contactDetails.phoneNumber,
          contactDetails.isdCode
        ),
      });
    }
  };

  const renderSubmitButton = () => {
    return (
      <Button type="submit" disabled={disabled}>
        {buttonText}
      </Button>
    );
  };

  const handleDownloadFile = () => {
    if (curriculumPdf || reportLink) {
      return (
        <a
          ref={anchorRef}
          href={curriculumPdf ? `${s3Url}/assets/uploads/curriculum/${curriculumPdf}` : reportLink}
          className="absolute bottom-0 hidden"
          download=""
        >
          &apos;&apos;
        </a>
      );
    }
    return undefined;
  };

  const handleDownloadFileLoggedIn = () => {
    const href = curriculumPdf ? `${s3Url}/assets/uploads/curriculum/${curriculumPdf}` : reportLink;

    if (href) {
      const anchor = document.createElement('a');
      anchor.href = href;
      anchor.download = '';
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      document.body?.removeChild(anchor);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timer;
    if (contactDetails.phoneNumber) {
      if (currentTimerCount > 0) {
        timer = setInterval(() => {
          setCurrentTimerCount((prev: number) => prev - 1);
        }, 1000);
      }
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [currentTimerCount]);

  useEffect(() => {
    if (downloadDirectly) {
      handleDownloadFileLoggedIn();
      handleDownload();
    }
  }, [downloadDirectly]);

  useEffect(() => {
    if (modalType === ModalType.CATEGORY_PAGE_FORM) {
      getFilteredCourseData(1);
    }
  }, []);

  useEffect(() => {
    if ((dropDownWorkExperience || dropDownBackground) && scrollableDivRef.current) {
      scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
    }
  }, [dropDownWorkExperience, dropDownBackground]);

  useEffect(() => {
    if (courseDetails?._id) {
      // getIsCourseBought();
      setIsCourseBought(checkIsCourseBought(courseDetails?._id));
    }
  }, [courseDetails]);

  useEffect(() => {
    let timer: NodeJS.Timer;
    if (saving && count > 0) {
      timer = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [saving, count]);

  const updatePhoneNumberFieldInputId = () => {
    const divElement =
      leadCaptureType === LeadCaptureType.MODAL
        ? document.getElementById('phoneNumber')
        : document.getElementById('phoneNumber_input_field');

    // Check if the div element exists
    if (divElement) {
      // Find the input element within the div
      const inputElement = divElement.querySelector('input');

      // Check if input element exists
      if (inputElement) {
        // Update the id attribute
        inputElement.id =
          leadCaptureType === LeadCaptureType.MODAL ? 'phoneNumber' : 'phoneNumber_input_field'; // Replace 'your_custom_id' with your desired id
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      // fields to update id of input field for lead capture
      updatePhoneNumberFieldInputId();
    }, 100);
  }, []);

  return (
    <div>
      {leadCaptureType === LeadCaptureType.FORM && (
        <LeadCaptureForm
          type={type}
          msgLineOne={msgLineOne}
          msgLineTwo={msgLineTwo}
          enquiryType={enquiryType}
          count={count}
          modalType={modalType}
          renderInput={renderInput}
          renderPhoneNumber={renderPhoneNumber}
          renderOtpButton={renderOtpButton}
          renderOtpField={renderOtpField}
          renderEmailField={renderEmailField}
          renderBackgroundDropDown={renderBackgroundDropDown}
          renderWorkExperienceDropDown={renderWorkExperienceDropDown}
          renderSubmitButton={renderSubmitButton}
          renderSelectProgramDropdown={renderSelectProgramDropdown}
          setDialogOpen={setDialogOpen}
          dialogOpen={dialogOpen}
          saving={saving}
          handleSubmit={handleSubmit}
          captchaToken={captchaToken}
          setCaptchaToken={setCaptchaToken}
          isCaptchaEnabled={isCaptchaEnabled}
        />
      )}

      {/* for modal */}
      {modelOpen ? (
        <Dialog
          open={modelOpen}
          closeModal={closeModal}
          isOutSideClick
          className={`regular:!w-[90%] ${
            saving ? 'regular:!w-[412px] regular:!h-fit' : 'large:!w-1/2 !p-6 '
          } rounded`}
          titleWrapperClass="border-none !pb-0  !hidden"
        >
          {downloadDirectly || saving ? (
            <Saving type={type} msgLineOne={msgLineOne} msgLineTwo={msgLineTwo} count={count} />
          ) : (
            <LeadCaptureModal
              img={img || ''}
              type={type}
              enquiryType={enquiryType}
              modalType={modalType}
              renderInput={renderInput}
              renderPhoneNumber={renderPhoneNumber}
              renderOtpButton={renderOtpButton}
              renderOtpField={renderOtpField}
              renderEmailField={renderEmailField}
              renderBackgroundDropDown={renderBackgroundDropDown}
              renderWorkExperienceDropDown={renderWorkExperienceDropDown}
              renderSubmitButton={renderSubmitButton}
              closeModal={closeModal}
              isLoggedIn={isLoggedIn}
              scrollableDivRef={scrollableDivRef}
              handleDownloadFile={handleDownloadFile}
              handleSubmit={handleSubmit}
              captchaToken={captchaToken}
              setCaptchaToken={setCaptchaToken}
              isCaptchaEnabled={isCaptchaEnabled}
            />
          )}
        </Dialog>
      ) : (
        <div />
      )}
    </div>
  );
};

export default LeadCapture;
